import { Routes } from '@angular/router';
import { CookiesPolicyComponent } from './container/cookies-policy/cookies-policy.component';
import { PrivacyPolicyComponent } from './container/privacy-policy/privacy-policy.component';
import { RegulationsComponent } from './container/regulations/regulations.component';

export const LEGAL_ROUTES: Routes = [
    {
        path: 'regulations',
        component: RegulationsComponent,
        data: { title: 'regulations' },
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        data: { title: 'privacy-policy' },
    },
    {
        path: 'cookies-policy',
        component: CookiesPolicyComponent,
        data: { title: 'cookies-policy' },
    },
];
